import { SET_LOADING } from './actionTypes';

export const setLoader = param => ({
  type: SET_LOADING,
  payload: param,
});
